export default "__VITE_ASSET__BkO95xrd__"